import { render, staticRenderFns } from "./ParceiroListFiltroModalItemServicos.vue?vue&type=template&id=40f8408a"
import script from "./ParceiroListFiltroModalItemServicos.vue?vue&type=script&lang=js"
export * from "./ParceiroListFiltroModalItemServicos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports